// ** Vertical Menu Components
import VerticalNavMenuLink from './VerticalNavMenuLink'
import VerticalNavMenuGroup from './VerticalNavMenuGroup'
import VerticalNavMenuSectionHeader from './VerticalNavMenuSectionHeader'

// ** Utils
import {
    canViewMenuGroup,
    canViewMenuItem,
    resolveVerticalNavMenuItemComponent as resolveNavItemComponent
} from '@utils/misc'
import {useSelector} from "react-redux";
//import Skeleton from "@material-ui/lab/Skeleton";

const VerticalMenuNavItems = props => {
    // ** Context
    /*const ability = useContext(AbilityContext)*/

    // ** Components Object
    const Components = {
        VerticalNavMenuSectionHeader,
        VerticalNavMenuGroup,
        VerticalNavMenuLink
    }
    const auth = useSelector(state => state.auth)
    // ** Render Nav Menu Items
    return props.items.filter(p => p.active === true).map((item, index) => {
        const TagName = Components[resolveNavItemComponent(item)]
        if (item.children) {
            return canViewMenuGroup(item, auth) && <TagName item={item} index={index} key={item.id} {...props}  />
        }
        return canViewMenuItem(item, auth) && <TagName key={item.id || item.header} item={item} {...props} />
    })
}

export default VerticalMenuNavItems
